module.exports = __webpack_public_path__ + "img/saishianpai-icon-2.695c8ccb.png";